import { Link } from "react-router-dom";
import { SquaresFour, ArrowRight } from "@phosphor-icons/react";

export default function ZoneTavoliSection() {
  return (
    <div data-testid="setsection-zone">
      <section className="bg-white border border-zinc-200 rounded-lg p-5 space-y-3">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-zinc-100 text-zinc-600 flex items-center justify-center">
            <SquaresFour size={20} weight="bold" />
          </span>
          <div>
            <h2 className="font-display font-semibold text-zinc-900">Zone e tavoli</h2>
            <p className="text-xs text-zinc-500">Sale, tavoli e mappa visuale si gestiscono nella sezione Sala, collegata in tempo reale alle prenotazioni.</p>
          </div>
        </div>
        <Link to="/sala" data-testid="zone-link"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-zinc-900 text-white text-sm font-semibold">
          Apri Sala e tavoli <ArrowRight size={16} />
        </Link>
      </section>
    </div>
  );
}
